module.exports = [
  "Gewerbe",
  "Läden/SB-Märkte",
  "Ausstellungsfläche",
  "SB-Markt",
  "Einkaufszentrum",
  "Kaufhaus",
  "Verkaufshalle",
  "Factory Outlet",
  "Kiosk",
  "Laden",
  "Verkaufsfläche",
  "Büro / Praxis / Ausstellungsräume",
  "Büro/Praxen",
  "Büro/Praxis",
  "Atelier",
  "Loft",
  "Büro",
  "Büroetage",
  "Bürozentrum",
  "Bürohaus",
  "Büro& Lagergebäude",
  "Büro- u. Geschäftsgebäude",
  "Büro- und Geschäftsgebäude",
  "Büro- und Praxisflächen",
  "Ladenflächen",
  "Gewerbezentrum",
  "Praxis",
  "Praxisetage",
  "Praxishaus",
  "Wohn- u. Geschäftsgebäude",
  "Prod./ Lager / Gewerbehallen",
  "Ausstellungsfläche (Produktion)",
  "Halle",
  "Industriehalle",
  "Industriehalle mit Freifläche",
  "Lagerfläche",
  "Lager mit Freifläche",
  "Lagerhalle",
  "Hochregallager",
  "Kühlhaus",
  "Kühlregallager",
  "Speditionslager",
  "Servicefläche",
  "Werkstatt",
  "Gastronomie / Beherbergungen",
  "Bar",
  "Cafe",
  "Diskothek",
  "Ferienbungalows",
  "Gaststätte",
  "Gästehaus",
  "Hotel",
  "Hotelanwesen",
  "Hotel garni",
  "Pension",
  "Restaurant",
  "Land- / Forstwirtschaft",
  "Anwesen",
  "Bauernhof",
  "Reiterhof",
  "Weingut",
  "Sonstige Objekte",
  "Freizeitanlage",
  "Gewerbefläche",
  "Gewerbeeinheit",
  "Gewerbepark",
  "Gewerbezentrum",
  "Spezialobjekt",
  "Werkstatt",
  "Werkstatt (Produktion)",
  "Gastgewerbe",
  "Laden/Einzelhandel",
  "Hallen/Lager/Produktion",
  "Land/Forstwirtschaft",
  "Bürofläche",
  "Gewerbeflächen",
  "Produktions- und Lagerflächen",
];



// WEBPACK FOOTER //
// ./src/data/business.js